/**
 * Feature Settings Module
 */
import {
  categorySettingsData
} from './data';

const state = {
}

// getters
const getters = {
  featureSettings: (state, getters) => categorySettingsData[getters.roimaticCategory].featureSettings,
  supportedMenus: (state, getters) => categorySettingsData[getters.roimaticCategory].supportedMenus,
  campaignLaunchSteps: (state, getters)=>categorySettingsData[getters.roimaticCategory].campaignLaunchSteps,
  creativesOrder: (state, getters)=>categorySettingsData[getters.roimaticCategory].creativesOrder,
  storeProfileSettings: (state, getters) => categorySettingsData[getters.roimaticCategory].storeProfileSettings
}

export default {
  state,
  getters
}